/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider-normail.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
// import Swiper from "swiper/bundle";

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Setting - Normal Slider - デフォルト
 */
if (window.matchMedia("(min-width: 600px)").matches) { var initialSlide = 1; var spaceBetween = 40; } else { var initialSlide = 0; var spaceBetween = 20; }
const option = {
  slidesPerView: "auto",
  initialSlide: initialSlide,
  centeredSlides: true,
  spaceBetween: spaceBetween,
  preventClicks: true,
  navigation: {
    nextEl: '.slider-button.next',
    prevEl: '.slider-button.prev',
  },
};

/**
 * Action - Normal Slider - デフォルト
 */
if (window.document.body.classList.contains("interviewee")) {
  const sliderFadeNormal = new Swiper(".slider-normal", option);
}

/**
 * Setting - Media Slider - デフォルト
 */
const option_department = {
  slidesPerView: "auto",
  initialSlide: 0,
  spaceBetween: 20,
  preventClicks: true,
  navigation: {
    nextEl: '.slider-button.next',
    prevEl: '.slider-button.prev',
  },
};

/**
 * Action - Media Slider - デフォルト
 */
if (window.document.body.classList.contains("department")) {
  const mediaSlider = new Swiper(".media-slider", option_department);
}